import { useEffect, useState, React, useCallback } from "react";
import { io } from "socket.io-client";
import "./viewer.css";
import Global_var from "../utils/Global_var";
import { useParams, useSearchParams } from "react-router-dom";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import dayjs from "dayjs";
import PhonelinkIcon from '@mui/icons-material/Phonelink';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import InfosCard from "../component/infos_card";
function Viewer() {
  let [searchParams, setSearchParams] = useSearchParams();

  let { roomID } = useParams();
  const [socket, setSocket] = useState();
  const [SessionDataRaw, setSessionDataRaw] = useState({});
  const [SessionData, setSessionData] = useState({});
  const [Error, setError] = useState("");
  const [headersSelectValue, setHeadersSelectValue] = useState("lastall");
  const [LineToAnimate, setLineToAnimate] = useState('');
  const [DriverDetailsDisplay, setDriverDetailsDisplay] = useState(false);
  const [DeviceDisplay, setDeviceDisplay] = useState('phone');
  const [ValueTimeOptionFilter, setValueTimeOptionFilter] = useState(0);

  let interval;

  useEffect(() => {
    //setup socket.io
    const s = io(Global_var.live_server);
    setSocket(s);

    return () => {
      s.disconnect();
      clearInterval(interval)
    };
  }, []);

  useEffect(() => {
    console.log(SessionData);
    const timer = document.getElementById('timer')
    if (!SessionData?.state?.[0] && SessionData?.races?.[0]?.duration) {
      timer && (timer.innerHTML = secondsToTimeMS(SessionData?.races?.[0]?.duration))
    }
  }, [SessionData, DriverDetailsDisplay, DeviceDisplay]);

  const SessionDataRawFilter = useCallback((TimeLimit) => {
    let newSessionDataRaw = JSON.parse(JSON.stringify(SessionDataRaw));
    let newSessionData = newSessionDataRaw;
    let startTime = newSessionData?.races?.[0].date;
    let diffTime = dayjs().diff(dayjs(startTime))
    newSessionData?.races?.[0]?.drivers?.forEach((driver, i1) => {
      newSessionData.races[0].drivers[i1].laps = driver.laps.filter(
        (lap) =>
          diffTime - lap.endTimestamp < TimeLimit
      );
    });
    setSessionData(newSessionData);
  }, [SessionDataRaw])

  const TimeOptionFilter = (TimeLimit) => {
    if (TimeLimit === 0) {
      setHeadersSelectValue('lastall')
    }
    else {
      setHeadersSelectValue(TimeLimit)
      setValueTimeOptionFilter(TimeLimit)
      SessionDataRawFilter(TimeLimit)
    }
  }
  useEffect(() => {
    SessionData?.races && SessionDataRaw?.races?.[0]?.drivers?.map((driver, i1) => {
      if (JSON.stringify(driver.laps) !== JSON.stringify(SessionData?.races?.[0]?.drivers.find(driver2 => driver2.driverUuid === driver.driverUuid).laps)) {
        setLineToAnimate(driver.driverUuid)
      }
    })
    if (headersSelectValue === "lastall" || headersSelectValue === "custom") {
      setSessionData(SessionDataRaw);
    } else if (headersSelectValue !== "custom") {
      SessionDataRawFilter(headersSelectValue);
    }
  }, [SessionDataRaw, headersSelectValue, SessionDataRawFilter]);

  useEffect(() => {
    if (socket) {
      socket.on("connect", () => {
        socket.emit("joinRoom", roomID, (SessionDataArg) => {
          if (SessionDataArg.status !== 200) {
            setError(SessionDataArg.message);
          } else {
            setError("");
            setSessionDataRaw(SessionDataArg.data);
          }
        });
      });
      socket.on("createSession", (SessionDataArg) => {
        if (SessionDataArg.status !== 200) {
          setError(SessionDataArg.message);
        } else {
          setError("");
          setSessionDataRaw(SessionDataArg.data);
        }
      });
      socket.on("addLaps", (SessionDataArg) => {
        if (SessionDataArg.status !== 200) {
          setError(SessionDataArg.message);
        } else {
          setError("");
          setSessionDataRaw(SessionDataArg.data);
        }
      });
    }
  }, [socket, roomID]);

  const DeviceHandleChange = () => {
    if (DeviceDisplay === 'phone') {
      setDeviceDisplay('tv')
    }
    else if (DeviceDisplay === 'tv') {
      setDeviceDisplay('phone')
    }
  }

  const secondsToTimeMSC = (time) => {
    time = Math.trunc(parseInt(time) / 10) * 10;
    (time < 0) && (time = 0)
    return (
      ('0' + ~~(((time / 1000) % 3600) / 60)).slice(-2) +
      ':' +
      ('0' + (~~(time / 1000) % 60)).slice(-2) +
      '.' +
      ('0' + (~~time % 1000) / 10).slice(-2)
    );
  };
  const secondsToTimeMS = (time) => {
    time = Math.trunc(parseInt(time) / 10) * 10;
    (time < 0) && (time = 0)
    return (
      ('0' + ~~(((time / 1000) % 3600) / 60)).slice(-2) +
      ':' +
      ('0' + (~~(time / 1000) % 60)).slice(-2)
    );
  };
  const secondsToTimeSC = (time) => {
    time = Math.trunc(parseInt(time) / 10) * 10;
    (time < 0) && (time = 0)
    var second = ~~((time / 1000) % 3600);
    second < 10 && (second = '0' + second);
    const cent = ('0' + (~~time % 1000) / 10).slice(-2);
    return second + '.' + cent;
  };

  const displayBest = (laps) => {
    return laps && Math.min(...laps?.map((lap, i1) => {
      if (i1 !== 0) {
        return lap.endTimestamp - laps[i1 - 1].endTimestamp
      }
    }).splice(1))
  };

  const displayLast = (laps) => {
    if (laps?.length > 1) {
      return parseInt(
        laps?.[laps?.length - 1]?.endTimestamp -
        laps?.[laps?.length - 2]?.endTimestamp
      );
    } else {
      return parseInt(laps?.[laps?.length - 1]?.endTimestamp);
    }
  };

  useEffect(() => {
    console.log(SessionData);
    const timer = document.getElementById('timer')
    var CumuledPauseTime = 0
    var firstLastPause = 0;
      function forTimeCumul(x) {
          let y
          for (let i = x; i < SessionData?.state.length; i++) {
            if (SessionData?.state?.[i]?.status === 'paused') {
              var PauseTime = SessionData.state[i].date
              firstLastPause = [i];
              var RunningTime
              for (y = i; y < SessionData?.state.length; y++) {
                if (SessionData.state[y].status === ('running')) {
                  RunningTime = SessionData.state[y].date
                  CumuledPauseTime = CumuledPauseTime + dayjs(RunningTime).diff(PauseTime)
                  break;
                }
              }
              (y && (y < SessionData?.state.length)) && forTimeCumul(y)
              break;
            }
        }
        }
    if(timer && (SessionData?.state?.[0]?.status === 'running')){forTimeCumul(0)}
    if (timer && (SessionData?.state?.[0]?.status === 'running') && (SessionData?.state?.[SessionData?.state.length - 1]?.status != 'finished')) {    
      if (SessionData?.state?.[SessionData?.state.length - 1]?.status === 'paused') {
        SessionData?.state?.[SessionData?.state.length - 1]?.date && (timer.innerHTML = secondsToTimeMS(dayjs(SessionData?.state?.[0]?.date).add(SessionData?.races?.[0]?.duration + CumuledPauseTime, 'ms').diff(SessionData?.state?.[SessionData?.state.length - 1]?.date)))
      }
      else {
        !interval && (interval = setInterval(() => {
          SessionData?.state?.[0]?.date && (timer.innerHTML = secondsToTimeMS(dayjs(SessionData?.state?.[0]?.date).add(SessionData?.races?.[0]?.duration + CumuledPauseTime, 'ms').diff(dayjs())))
        }, 10))
      }
    }
    else if (timer && SessionData?.state?.[SessionData?.state.length - 1]?.status === 'finished') {
      console.log(firstLastPause)
      SessionData?.state?.[SessionData?.state.length - 1]?.date && (timer.innerHTML = secondsToTimeMS(dayjs(SessionData?.state?.[0]?.date).add(SessionData?.races?.[0]?.duration + CumuledPauseTime, 'ms').diff(SessionData?.state?.[firstLastPause]?.date)))
    }
    return () => {
      clearInterval(interval);
    }
  }, [SessionData, DriverDetailsDisplay, DeviceDisplay]);


  function RowsDisplay() {
    return (
      <tbody>
        {SessionData?.races?.[0]?.drivers
          ?.sort(
            (firstItem, secondItem) =>
              secondItem.laps?.length - firstItem.laps?.length ||
              (
                (SessionData?.races?.[0]?.kind === 'race')
                  ?
                  (firstItem.laps[firstItem.laps.length - 1]?.endTimestamp - secondItem.laps[secondItem.laps.length - 1]?.endTimestamp)
                  :
                  ((firstItem.laps[firstItem.laps.length - 1]?.endTimestamp - firstItem.laps[0]?.endTimestamp) - (secondItem.laps[secondItem.laps.length - 1]?.endTimestamp - secondItem.laps[0]?.endTimestamp))
              )
          )
          ?.map((driver, i1) => (
            <tr key={i1} id={(driver.laps[0] && (driver.driverUuid === LineToAnimate)) ? "yellowAnim" : "noAnim"} onClick={() => {
              (DeviceDisplay === 'phone') && setSearchParams({ d: driver.transponderId });
              setDriverDetailsDisplay(true)
            }}>
              <td>{i1 + 1}</td>
              <td>
                {(DeviceDisplay === 'phone') ? <button className="Button_driver_details" >
                  {driver?.name || "-"}
                </button> : <div className="Button_driver_details" >
                  {driver?.name || "-"}
                </div>}

              </td>
              <td>{driver.laps?.length ? driver.laps?.length - 1 : "-"}</td>
              <td>
                {
                  (driver.laps?.[driver.laps?.length - 1]?.endTimestamp && SessionData?.races?.[0] && SessionData?.state?.[0])
                    ?
                    secondsToTimeMSC(
                      (SessionData?.races?.[0]?.kind === 'race') ?
                        driver.laps?.[driver.laps?.length - 1]?.endTimestamp /*- dayjs(SessionData?.state?.[0].date).diff(dayjs(SessionData?.races?.[0].date))*/
                        :
                        driver.laps?.[driver.laps?.length - 1]?.endTimestamp - driver.laps?.[0]?.endTimestamp
                    )
                    : driver.laps[0] ? '00:00.00':'--:--.--'
                }
              </td>
              <td>
                {driver.laps?.[1]
                  ? secondsToTimeSC(displayLast(driver.laps))
                  : '--.--'}
              </td>
              <td>
                {driver?.laps?.[1]
                  ? secondsToTimeSC(displayBest(driver.laps))
                  : '--.--'}
              </td>
            </tr>
          ))}
      </tbody>
    );
  }

  function SelectDisplay() {
    return (
      <div className="select_filter_cont">
        <select
          value={headersSelectValue}
          onChange={(e) => {
            setHeadersSelectValue(e.target.value);
          }}
        >
          <option value="lastall">Last All</option>
          <option value="300000">Last 5 Minutes</option>
          <option value="600000">Last 10 Minutes</option>
          <option value="900000">Last 15 Minutes</option>
          <option value="3600000">Last 60 Minutes</option>
          {(ValueTimeOptionFilter && (ValueTimeOptionFilter != 0)) && <option value={ValueTimeOptionFilter}>{`${HoursInputFilterValue} hours, ${MinutesInputFilterValue} minutes`}</option>}
          <option value="custom">Custom</option>

        </select>
      </div>
    );
  }
  const [MinutesInputFilterValue, setMinutesInputFilterValue] = useState(0);
  const [HoursInputFilterValue, setHoursInputFilterValue] = useState(0);
  function FormToMs(hours, minutes) {
    return hours * 3600000 + minutes * 60000;
  }

  /*  -------------------- Driver Details functions ------------------------  */


  const DriverDetails = () => {
    const displayLapTime = (lap, i1) => {
      if (i1 === 0) {
        return lap.endTimestamp
      }
      else if (i1 > 0) {
        return lap.endTimestamp - DriverDetailsData()?.laps[i1 - 1].endTimestamp
      }
    }
    function RowsLapsDisplay() {
      return (
        <tbody className="table_drivers_details_all_laps">
          {DriverDetailsData()?.laps.slice(0).reverse().map((lap, i1) => (
            (DriverDetailsData()?.laps.length - i1 != 0) && <tr key={i1 - DriverDetailsData()?.laps.length}>
              <td>{DriverDetailsData()?.laps.length - i1 - 1}</td>
              <td>
                {(SessionData?.races?.[0] && SessionData?.state?.[0]) && secondsToTimeMSC((SessionData?.races?.[0]?.kind === 'race') ? lap?.endTimestamp - dayjs(SessionData?.state?.[0].date).diff(dayjs(SessionData?.races?.[0].date)) : lap?.endTimestamp - DriverDetailsData()?.laps[0].endTimestamp)}
              </td>
              <td>
                {secondsToTimeSC(displayLapTime(lap, DriverDetailsData()?.laps.length - i1 - 1))
                }</td>
            </tr>
          ))}
        </tbody>
      );
    }
    const DriverDetailsData = () => {
      return SessionData?.races?.[0]?.drivers?.find((driver) => driver.transponderId == searchParams.get("d"))
    }
    const GetAllTimes = (laps) => {
      //return all laps times except the first one
      return laps?.map((lap, i1) => {
        if (i1 != 0) {
          return lap.endTimestamp - laps[i1 - 1].endTimestamp
        }
      }).splice(1)
    }
    const GetAverage = (LapsDuration) => {
      const average = LapsDuration?.reduce((a, b) => a + b, 0) / LapsDuration?.length;
      return average
    }
    const GetNBest = (LapsDuration, topsNum) => {
      function compareNumbers(a, b) {
        return a - b;
      }
      return LapsDuration?.sort(compareNumbers)?.slice(0, topsNum)
    }
    const GetStandardDeviation = (LapsDuration) => {
      const allTimes = GetAllTimes(LapsDuration)
      const ecart = []
      allTimes?.map((lapDuration, i1) => { ecart.push(Math.pow(lapDuration - GetAverage(allTimes), 2)) })
      return Math.sqrt(ecart.reduce((a, b) => a + b, 0) / (allTimes?.length - 1))
    }
    const GetConsistency = (ecartType, Average) => {
      return Math.abs((ecartType / Average - 1) * 100).toFixed(0) + "%"
    }
    const displayBestNLaps = (LapsDuration) => {
      const ThreeLaps = []
      LapsDuration.map((lap, i1) => {
        if (i1 >= 3) {
          ThreeLaps.push(parseInt(lap.endTimestamp - LapsDuration[i1 - 3].endTimestamp))
        }
      })
      return Math.min(...ThreeLaps)
    }
    return (
      <div class='DriverDetails_cont'>
        <div class='DriverDetails wrap'>
          <div class='DriverDetails_header'>
            <button id='DriverDetails_back'
              onClick={() => { setSearchParams({}); setDriverDetailsDisplay(false) }}>
              <ArrowBackIosIcon sx={{ fontSize: '15px' }} /> back
            </button>
            <h2>{DriverDetailsData()?.name}</h2>
            <div></div>
          </div>
          <table class='DriverDetails_driver_infos'>
            <tr>
              <td>
                Best
              </td>
              <td>
                <h3>Lap</h3>
                <p>{DriverDetailsData()?.laps[1] ? secondsToTimeSC(displayBest(DriverDetailsData()?.laps)) : '--.--'}</p>
              </td>
              <td>
                <h3>3 Laps</h3>
                <p>{DriverDetailsData()?.laps[3] ? secondsToTimeSC(displayBestNLaps(DriverDetailsData()?.laps)) : '--.--'}</p>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                Average
              </td>
              <td>
                <h3>Lap</h3>
                <p>{DriverDetailsData()?.laps[1] ? secondsToTimeSC(GetAverage(GetAllTimes(DriverDetailsData()?.laps))) : '--.--'}</p>
              </td>
              <td>
                <h3>Top 5</h3>
                <p>{DriverDetailsData()?.laps.length >= 6 ? secondsToTimeSC(GetAverage(GetNBest(GetAllTimes(DriverDetailsData()?.laps), 5))) : '--.--'}</p>
              </td>
              <td>
                <h3>Top 10</h3>
                <p>{DriverDetailsData()?.laps.length >= 11 ? secondsToTimeSC(GetAverage(GetNBest(GetAllTimes(DriverDetailsData()?.laps), 10))) : '--.--'}</p>
              </td>
            </tr>
            <tr>
              <td>
                Advanced Stats
              </td>
              <td>
                <h3>Consistency</h3>
                <p>{DriverDetailsData()?.laps[2] ? GetConsistency(GetStandardDeviation(DriverDetailsData()?.laps), GetAverage(GetAllTimes(DriverDetailsData()?.laps))) : '-'}</p>
              </td>
              <td>
                <h3>Std dev</h3>
                <p>{DriverDetailsData()?.laps[2] ? secondsToTimeSC(GetStandardDeviation(DriverDetailsData()?.laps)) : '--.--'}</p>
              </td>
              <td></td>
            </tr>
          </table>
          {DriverDetailsData()?.laps[1] && <div className="table_cont">
            <table className="table">
              <thead>
                <tr>
                  <td>Lap</td>
                  <td>Total Time</td>
                  <td>Lap Time</td>
                </tr>
              </thead>
              <RowsLapsDisplay />
            </table>
          </div>}
        </div>
      </div>
    );
  };

  //   -------------------- Driver Details functions end ------------------------

  return Error == '' ? (
    <div className={(DeviceDisplay === 'phone') ? 'DeviceDisplay_Phone' : 'DeviceDisplay_Tv'}>
      <div className="header_viewer_cont">
        <div className="header_viewer wrap">
          <div className="header_app_content">
            <div className="header_app_title">
              <h1>LapMonitor Live</h1><h1>•</h1>
            </div>
            {(DeviceDisplay === 'tv') && <div className="course_infos_cont">
              <div className="duration_content">
                <h2 id='timer'>

                </h2>
              </div>
              <div className="kind_content">
                <h2>
                  {SessionData?.races?.[0]?.name + ' (' + SessionData?.races?.[0]?.kind + ')'}
                </h2>
              </div>
              <button className="SwitchDevice_button" onClick={DeviceHandleChange}>
                {(DeviceDisplay === 'phone') ? <LiveTvIcon /> : <PhonelinkIcon />}
              </button>
            </div>}
          </div>
          {headersSelectValue != 'custom' && <SelectDisplay />}
        </div>
        {headersSelectValue === 'custom' && <div className="header_viewer_custom_cont wrap"><div className="header_viewer_input">
          <input
            placeholder="hours"
            max="99"
            min="0"
            type="number"
            value={HoursInputFilterValue}
            onChange={(e) => setHoursInputFilterValue(String(e.target.value).slice(0, 2))}
          />
          <span>:</span>
          <input
            placeholder="minutes"
            max="99"
            min="0"
            type="number"
            value={MinutesInputFilterValue}
            onChange={(e) => setMinutesInputFilterValue(String(e.target.value).slice(0, 2))}
          />
          <button
            onClick={() => { TimeOptionFilter(FormToMs(HoursInputFilterValue, MinutesInputFilterValue)); }}>
            <RemoveRedEyeIcon />
          </button>
        </div>
          <SelectDisplay />
        </div>}
      </div>
      {searchParams.get("d") ? (
        <DriverDetails />
      ) : (
        <div className="page_cont">
          <div className="table_cont wrap">
            {(DeviceDisplay === 'phone') && <div className="course_infos_cont">
              <div className="duration_content">
                {/* {<h2>
                  {SessionData?.races?.[0]?.duration
                    ? secondsToTimeMSC(SessionData?.races?.[0]?.duration)
                    : "--:--"}
                </h2>} */}
                <h2 id='timer'>

                </h2>
              </div>
              <div className="kind_content">
                <h2>
                  {SessionData?.races?.[0]?.name + ' (' + SessionData?.races?.[0]?.kind + ')'}
                </h2>
              </div>
              <button className="SwitchDevice_button" onClick={DeviceHandleChange}>
                {(DeviceDisplay === 'phone') ? <LiveTvIcon color='red' /> : <PhonelinkIcon />}
              </button>
            </div>}
            <table className="table">
              <thead>
                <tr>
                  <td>Rank</td>
                  <td>Driver</td>
                  <td>Laps</td>
                  <td>Total</td>
                  <td>Last</td>
                  <td>Best</td>
                </tr>
              </thead>
              <RowsDisplay />
            </table>
          </div>

        </div>
      )}
    </div>
  ) : <InfosCard text={Error}/>;
}

export default Viewer;